export default __webpack_public_path__ + "static/media/tickets.46b67d12.png";